import { Button, Form } from 'antd'
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import TextArea from 'antd/es/input/TextArea'
import { actions } from '../../../../../store/reducers/assignment.reducer'
import { useParams } from 'react-router'
import { validateNoEmptySpaces } from '../../../../../utils/antd.helper'
import { useAutoFocusFirstInput } from '../../../../../../hooks/useAutoFocusFirstInput'

const DefineDescriptionStep = ({ moveToNextStep, generateAndProjectCriteria }) => {
    const { token, layerId } = useParams()

    const [form] = Form.useForm()
    useAutoFocusFirstInput()
    const [isWaitingForGenerateCriteria, setIsWaitingForGenerateCriteria] = useState(false)

    const handleSubmitClick = async () => {
        setIsWaitingForGenerateCriteria(true)
        const criteria = await generateAndProjectCriteria(
            token,
            layerId,
            form.getFieldValue('description').trim(),
        )
        setIsWaitingForGenerateCriteria(false)
        if (criteria) moveToNextStep()
    }

    // Add Ctrl+Enter functionality
    useEffect(() => {
        const handleKeyDown = event => {
            if (event.ctrlKey && event.key === 'Enter') {
                event.preventDefault()
                form.submit()
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [form])

    return (
        <Form
            name='define-description'
            autoComplete='off'
            form={form}
            onFinish={handleSubmitClick}
            requiredMark={false}
            layout='vertical'
        >
            <Form.Item
                name='description'
                label='Description'
                rules={[
                    { required: true, message: 'Please, enter the description' },
                    { validator: validateNoEmptySpaces },
                ]}
            >
                <TextArea
                    disabled={isWaitingForGenerateCriteria}
                    rows={12}
                    placeholder='Enter high level description to create pattern from'
                />
            </Form.Item>
            <Form.Item className='mb-0'>
                <Button type='primary' htmlType='submit' block loading={isWaitingForGenerateCriteria}>
                    Create
                </Button>
            </Form.Item>
        </Form>
    )
}

const mapDispatch = dispatch => {
    return {
        generateAndProjectCriteria(token, layerId, description) {
            return dispatch(actions.generateAndProjectCriteria(token, layerId, description))
        },
    }
}

export default connect(null, mapDispatch)(DefineDescriptionStep)
